import {
    billingAppName,
    mobileDataUsageMeterAppName,
    mobilityAppName,
    networkPerformanceReports,
    orderTrackerAppName,
    platformAppName,
    serviceRequestAppName,
    supportEnquiryAppName,
} from "@telstra-connect/utils/data";

/**
 * Enum defining the available BVT (Business Value Test) feature flags.
 * These flags are used to control the visibility and behavior of features
 * that are under testing or development for specific customer segments.
 *
 * **Important: You cannot hardcode bvt flag names in your code**
 */
export enum BvtFeatureFlags {
    TEDIG4751ProgrammableAdaptiveNetworks = "TEDIG4751ProgrammableAdaptiveNetworks",
    YPSLandingAble = "ypsLandingAble",
    tedig4308RefSearchWithAssetIdentifier = "tedig4308RefSearchWithAssetIdentifier"
}

export interface IFeatureFlagWithBVT {
    bvtEnabledFeature: boolean;
    flagState: boolean;
}

export type FlagApplicationNames =
  | typeof serviceRequestAppName
  | typeof platformAppName
  | typeof billingAppName
  | typeof orderTrackerAppName
  | typeof supportEnquiryAppName
  | typeof networkPerformanceReports
  | typeof mobileDataUsageMeterAppName
  | typeof mobilityAppName;

export interface IUseBvtFlagsCheckerProps {
    bvtFlagName: BvtFeatureFlags;
    cidn?: string;
    appName?: FlagApplicationNames;
}
